export function axAsType(x) {
    return ((x && x.__fast__) || this.axIsType(x)) ? x : null;
}
